import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Col, Form, Row, DatePicker } from 'antd';
import useStore from '../../../../store';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
import Enquiry from '..';
import { toJS } from 'mobx';
import { enquiryRequest } from '../../../../request/AuthRequest';


const EnquiryForm = observer((props) => {
	const { handleChange, onFinish, id, form } = props;
	const {AUTH: { lookupKeyList},
			ENQUIRY:{tourPackageList,getTourPackageList,tourPackageData,enquiryDetail}} = useStore();

	useEffect(() => {
		getTourPackageList();
		  form.setFieldsValue({
        	enquiryStatus: "Open",
    });
	}, []);
	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={false}
						name="enquiryType"
						label="Select Enquiry"
						placeholder="Select Enquiry"
						options={{
							values: lookupKeyList,
							value_key: 'lookupValue',
							text_key: {
								key: ['lookupValue'],
							},
						}}
						onChange={handleChange}
						rules={enquiryRequest.enquiryType}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						required
						name="name"
						label="Name"
						placeholder="Enter Name"
						onChange={handleChange}
						rules={enquiryRequest.name}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						required
						name="mobileNumber"
						label="Mobile Number"
						placeholder="Enter Mobile Number"
						onChange={handleChange}
						rules={enquiryRequest.mobileNumber}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						name="email"
						label="Email"
						placeholder="Enter Email"
						onChange={handleChange}
						rules={enquiryRequest.email}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						name="city"
						label="City"
						placeholder="Enter City"
						onChange={handleChange}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						name="propertyName"
						label="Property Name"
						placeholder="Enter Property Name"
						onChange={handleChange}
					/>
				</Col>

				<Col span={12}>
					<InputComponent
						required
						type="textarea"
						name="description"
						label="Description"
						placeholder="Enter Description"
						onChange={handleChange}
						rows={4}
						rules={enquiryRequest.description}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						type="select"
						showSearch={true}
						name="tourPackageId"
						label="Select Tour Package"
						placeholder="Select Tour Package"
						options={{
							values:
								(tourPackageList.length && tourPackageList) ||
								(enquiryDetail && [
									{
										tourPackageId: enquiryDetail.tourPackageId,
										title: enquiryDetail.title,
									},
								]),
							value_key: 'tourPackageId',
							text_key: 'title',
						}}
						onChange={handleChange}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						name="price"
						label="Price"
						placeholder="Enter Price"
						onChange={handleChange}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						name="packageName"
						label="Package Name"
						placeholder="Enter Package Name"
						onChange={handleChange}
					/>
				</Col>

				<Col span={6}>
					<InputComponent
						name="noOfAdult"
						label="No Of Adult"
						placeholder="Enter No Of Adult"
						onChange={handleChange}
					/>
				</Col>
				<Col span={6}>
					<Form.Item
						label="Preferred Date"
						name="preferredDate"
						getValueProps={(value) => ({
							 value: value ? dayjs(value) : undefined,
						})}
						getValueFromEvent={(date) => {
							 return date ? date.format('YYYY-MM-DD[T]HH:mm:ss') : null;
						}}
					>
						<DatePicker
							placeholder="Select Preferred Date"
							format="DD/MM/YYYY"
							onChange={handleChange}
							style={{ width: '100%' }}
						/>
					</Form.Item>
				</Col>
				<Col span={6}>
				<InputComponent
						required
						type="select"
						showSearch={false}
						name="enquiryStatus"
						label="Select Enquiry Status"
						placeholder="Select Enquiry Status"
						options={{
							values: [
								{ value: 'Open', label: 'Open' },
								{ value: 'InProgress', label: 'InProgress' },
								{ value: 'Closed', label: 'Closed' },
							],
							value_key: 'value',
							text_key: 'label',}}
						onChange={handleChange}
						rules={enquiryRequest.enquiryStatus}
					/>
				</Col>
			</Row>
		</Form>
	);
});

export default EnquiryForm;